import React from 'react';
const TreeContext = /*#__PURE__*/React.createContext(null);
export default TreeContext;